module.exports = __webpack_public_path__ + "static/media/s2-top-left.d92051fc.png";